<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
      
      <div class="card-body p-15 p-sm-20 p-md-25">
        <div class="custom-search">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Zone :</label>
                <v-select
                class="custom-select-height"
                  v-model="zone"
                  :options="zoneList"
                  label="name"
                >
                  <template #option="{ name, nb_bons }">
                  <span>{{ name }} - {{ nb_bons }} Colis</span>
                </template>

                </v-select>

              </div>
            </div>
           
            <div class="col-md-12">
              <button
                style="margin-top: 1.2rem;"
                v-if="auth.can('ADD_BP_Z')"
                class="btn btn-primary"
                @click="addPaymentZone"
              >
                Ajouter
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import router from "@/router";
export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    // Declare reactive variables
    const zoneList = ref<Array<any>>([]);
    const zone = ref<any>({});
    const isLoader = ref(false);

   

    
    const addPaymentZone = async () => {
      if (!zone.value?.id) {
        showToast('Merci de remplir tous les champs', "error");
        return;
      }
      const data = new FormData();
      data.append('zoneId', String(zone.value.id));
      data.append('zone_name', zone.value.name);
      data.append('user_id', user?.id ? String(user.id) : '');

      isLoader.value = true;
      try {
        const res = await api.post(`/api/auth/new_zone_payment`, data);
        isLoader.value = false;
        if (res.data.message === 'success') {
          const routeData = router.resolve({ name: 'EditPaymentZonePage', params: { id: res.data.PayZone.id,  refNote: res.data.PayZone.pay_z_ref } });
          window.open(routeData.href, '_blank');
        }
      } catch (error) {
        isLoader.value = false;
        showToast('Something went wrong! Please try again', "error");
      }
    };


    onMounted(async () => {
      // Load agencies list on mount
      try {
        const res = await api.get('/api/auth/list_zone_bp');
        zoneList.value = res.data;
      } catch (error) {
        showToast('Impossible de charger les agences', "error");
      }
    });

    return {
      user,
      zoneList,
      isLoader,
      zone,
      auth,
      addPaymentZone,
    };
  },
});
</script>
